import { render } from "./App.vue?vue&type=template&id=f8dfae2c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f8dfae2c&lang=scss&scoped=true"

import exportComponent from "/soma-ui-vue-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8dfae2c"]])

export default __exports__